import Api from './api';

const LocalService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/local/listar',
            params: params
        })
        return response
    },
    categorias: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/local/categorias',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/local/buscar?${params}`)
        return response
    }
}

export default LocalService;